import React, { useState } from 'react';
import SectionContainer from '../layout/SectionContainer.jsx';
import SectionNav from '../layout/SectionNav.jsx';
import VideoPlayer from '../components/VideoPlayer.jsx';
import ContentContainer from '../layout/ContentContainer.jsx';

const NonSkippableVideoSection = ({url, navigationProps= {}, background = 'light', selectedLanguage, ...rest}) => {

	const [videoHasEnded, setVideoHasEnded] = useState(false);
	return (
		<SectionContainer
			background={background}
			Navigation={
				<SectionNav 
					{...navigationProps}
					canContinue={videoHasEnded}
					selectedLanguage={selectedLanguage}
				/>
			}
		>
			<ContentContainer>
				<VideoPlayer pip={false} playsInline={true} controls={false} autoPlay={true} onEnded={() => setVideoHasEnded(true)} url={url} />
			</ContentContainer>
		</SectionContainer>
	);

};


NonSkippableVideoSection.type = 'NonSkippableVideoSection';
NonSkippableVideoSection.hasNavigation = true;
NonSkippableVideoSection.spec = [{
	name: 'NonSkippableVideoSection',
	key: 'NonSkippableVideoSection',
	allowedFields: [],
	translatable: ['navigation.previousLabel', 'navigation.nextLabel', 'navigation.submitLabel', 'url'],
	fields: [{
		type: 'TextField',
		name: 'url',
		label: 'video url',
	}, {

	}],
}];
export default NonSkippableVideoSection;